import { Component, OnInit } from '@angular/core';
import { take } from "rxjs/operators";
import { ReferenceConfiguration } from "../shared/model/reference-configuration";
import { FacadeService } from "../shared/service-facade/facade.service";
import {CoreService, PageProps} from "../shared/services/core.service";
import {SettingsEnum} from "../shared/model/settings.enum";
import {HomepageEnum} from "../shared/model/homepage.enum";
import { MainLayoutService } from '../shared/services/main-layout.service';

//const mParticle = require("@mparticle/web-sdk");
@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  title = "";
  errorDescription = "";
  refCode = "";
  isFromBankingCenter = false;
  isInAuthenticatedFlow = false;
  // Default is TCB Homepage - This value will be overwritten by the Settings in Falcon.
  closeURL : string = HomepageEnum.TCB;
  errorContactMessage = "";
  contactEmail = "";


  constructor(
    private facade: FacadeService,
    private coreService: CoreService,
    private mainLayout: MainLayoutService,
  ) {
    this.facade.isInAuthenticatedFlow$.subscribe(val => {
      this.isInAuthenticatedFlow = val[0];
    });
  }

  ngOnInit(): void {
    this.coreService.disableBackButton();

    this.mainLayout.setPageTitle();

    if(this.facade.isFromBranch()) {
      this.isFromBankingCenter = true;
      this.closeURL =  this.facade.getStorageItem(SettingsEnum.BranchCancelUrl);
    } else {
      this.closeURL = this.facade.getStorageItem(SettingsEnum.CloseUrl);
    }

    let props = new PageProps();
    props.title = this.title;
    props.isHomePage = false;
    this.coreService.setPageProps(props)

    this.facade.globalSettingsLoaded.pipe(
      take(1)
    ).subscribe(settings => {
      this.populateLocalProperties(
        this.facade.getExceptionConfiguration()
      );
    });

    //comment mParticle, CDP scripts are live, remove the code later
    // mParticle.default.logPageView(
    //   "Application Failed",
    //   {page: window.location.toString()}
    // );
  }

  private populateLocalProperties(referenceConfiguration: ReferenceConfiguration): void {
    const { props, title, refCode } = referenceConfiguration;

    this.title = title;
    this.errorDescription = props.message;
    if (props.contactMessage) {
      if (props.contactMessage.includes("{{contactEmail}}")) {
        this.errorContactMessage = props.contactMessage.replace(new RegExp("{{contactEmail}}", 'g'), props.contactEmail);
      } else {
        this.errorContactMessage = props.contactMessage;
      }
    }

    this.contactEmail = props.contactEmail;
    this.refCode = refCode;
  }

  navigateTo(url: string): void {
    window.location.href = url;
  }
}
